import React, { useState } from 'react';
import LogoutButton from './LogoutButton';
import axios from 'axios';

const AddProduct = () => {
    // State for form inputs
    const [productName, setProductName] = useState('');
    const [productType, setProductType] = useState('');
    const [productId, setProductId] = useState('');
    const [productSku, setProductSku] = useState('');
    const [productImg, setProductImg] = useState('');
    const [productSize, setProductSize] = useState('');
    const [productQuantity, setProductQuantity] = useState('');
    const [responseMessage, setResponseMessage] = useState('');

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission

        const productData = {
            Product_Name: productName,
            Product_Type: productType,
            Product_ID: productId,
            Product_SKU: productSku,
            Product_Img: productImg,
            Product_Size: productSize,
            Product_Quantity: productQuantity,
        };

        try {
            const response = await axios.post(
                'https://st.tjdstore.in/api/addproduct.php',
                productData
            );
            setResponseMessage(response.data.message || 'Product added successfully!');
            // Reset the form fields
            setProductName('');
            setProductType('');
            setProductId('');
            setProductSku('');
            setProductImg('');
            setProductSize('');
            setProductQuantity('');
        } catch (error) {
            console.error('Error adding product:', error);
            setResponseMessage('Failed to add product. Please try again.');
        }
    };

    return (
        <div className="col-md-8">
            <h4 className="text-center">Add New Product</h4>
            <LogoutButton />
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <input
                        type="text"
                        className="form-control" placeholder="Product Name"
                        value={productName}
                        onChange={(e) => setProductName(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group mt-4">
                    <input
                        type="text"
                        className="form-control" placeholder="Product Type"
                        value={productType}
                        onChange={(e) => setProductType(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group mt-4">
                    <input
                        type="text"
                        className="form-control" placeholder="Product ID"
                        value={productId}
                        onChange={(e) => setProductId(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group mt-4">
                    <input
                        type="text"
                        className="form-control" placeholder="Product SKU"
                        value={productSku}
                        onChange={(e) => setProductSku(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group mt-4">
                    <input
                        type="url"
                        className="form-control" placeholder="Product Image URL"
                        value={productImg}
                        onChange={(e) => setProductImg(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group mt-4">
                    <input
                        type="text"
                        className="form-control" placeholder="Product Size"
                        value={productSize}
                        onChange={(e) => setProductSize(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group mt-4">
                    <input
                        type="number"
                        className="form-control" placeholder="Product Quantity"
                        value={productQuantity}
                        onChange={(e) => setProductQuantity(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="btn btn-primary btn-block">
                    Add Product
                </button>
            </form>
            {responseMessage && (
                <div className="mt-3 alert alert-info">{responseMessage}</div>
            )}
        </div>
    );
};

export default AddProduct;
